import React from 'react';
import { cn } from '../../lib/cn';

interface DotPatternProps {
  className?: string;
  dotSize?: number;
  dotColor?: string;
  backgroundColor?: string;
  gap?: number;
  fade?: boolean;
}

export const DotPattern: React.FC<DotPatternProps> = ({
  className,
  dotSize = 1.5,
  dotColor = 'rgba(14, 165, 233, 0.25)', // Primary blue with opacity
  backgroundColor = 'transparent',
  gap = 18,
  fade = true,
}) => {
  const patternId = React.useId();
  const maskId = React.useId();

  return (
    <div className={cn('pointer-events-none absolute inset-0 h-full w-full', className)}>
      <svg className="h-full w-full" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <pattern
            id={patternId}
            width={gap}
            height={gap}
            patternUnits="userSpaceOnUse"
            patternContentUnits="userSpaceOnUse"
          >
            <circle
              cx={gap / 2}
              cy={gap / 2}
              r={dotSize}
              fill={dotColor}
              className="animate-pulse-slow"
            />
          </pattern>
          {fade && (
            <radialGradient id={maskId}>
              <stop offset="0%" stopColor="white" stopOpacity="1" />
              <stop offset="50%" stopColor="white" stopOpacity="0.8" />
              <stop offset="100%" stopColor="white" stopOpacity="0.2" />
            </radialGradient>
          )}
        </defs>
        <rect
          width="100%"
          height="100%"
          fill={backgroundColor}
        />
        <rect
          width="100%"
          height="100%"
          fill={`url(#${patternId})`}
          mask={fade ? `url(#${maskId})` : undefined}
        />
      </svg>
    </div>
  );
};
